// Launch the video-call surface for a given partner. Centralized here (extract on
// the 3rd recurrence) so Messages, the order Chat tab and the freelancer profile
// all open it identically. A call is a separate context, so it opens in a new
// window — the shell tab stays intact, mirroring the legacy `window.open` launch.
//
// `partnerUserId` is a User id (the surface's `chat_partner` param is a User id,
// never an employee slug). Never call with a blank/guessed id — the caller must
// guard on presence, and this no-ops defensively if it's missing.
export function launchVideoCall(partnerUserId, { conversationSid, orderId } = {}) {
  if (partnerUserId == null || partnerUserId === "") return

  const params = new URLSearchParams()
  params.set("video_chats[chat_partner]", partnerUserId)
  if (conversationSid) params.set("video_chats[conversation_sid]", conversationSid)
  if (orderId != null && orderId !== "") params.set("video_chats[order_id]", orderId)

  const url = `/video_chats?${params.toString()}`
  window.open(url, "newwindow", "width=1200,height=750")
}
